import ko from "knockout";

import dateHelper from "../utils/dateHelper";
import logger from "../logger";

import { MaybeObservable } from "../interfaces/MaybeObservable";

declare global {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    interface KnockoutPunchesFilters {
        dateFormat(valueObs: MaybeObservable<string>): string;
    }
}

ko.filters.dateFormat = function (valueObs: MaybeObservable<string>) {
    const rawValue = ko.unwrap(valueObs);
    try {
        return dateHelper.toLocalDateFormat(rawValue, false);
    } catch (e) {
        logger.error("date filter error:", e);
        return rawValue; // Return the original value if transformation fails
    }
};
